import { curry, fromPairs, map, adjust, toPairs } from 'ramda'

const renameKeys = curry((fn, obj) =>
  fromPairs(map(adjust(0, fn), toPairs(obj)))
)
export default renameKeys
